export const getInputType = (isShowing: boolean) => {
  return isShowing ? 'text' : 'password';
};
export const getInputPlaceholder = (isShowing: boolean) => {
  return isShowing ? 'X$7#mP9&z@K!2qY' : '********';
};
export const getEyeSlashed = (isShowing: boolean) => {
  return isShowing ? 'eye-slash' : 'eye';
};
